import React, { Component } from 'react'
import { Row, Col, Button, FormGroup, Label, Input, Spinner } from 'reactstrap'
import Dropzone from 'react-dropzone'
import { FileIcon } from 'react-file-icon'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import filesize from 'filesize'
import TruncateString from 'react-truncate-string'
import AsyncSelect from '../Input/AsyncSelect'
import oikosApi from '../../../services/oikos'
import ModalConfirmacao from '../../Modals/ModalConfirmacao/ModalConfirmacao'
import { notifyError, notifySuccess } from '../../../utils/notify'

export default class AddFiles extends Component {
  constructor(props) {
    super(props)
    this.state = {
      files: props.files || [],
      salvarAnexoModalIsOpen: false,
      pendingFile: null,
      isLoadingUpload: false,
    }

    this.handleOnDropFiles = this.handleOnDropFiles.bind(this);
  }

  componentWillUnmount() {
    // Make sure to revoke the data uris to avoid memory leaks
    if (!this.props.pocket && this.state.files?.length > 0) {
      this.state.files.forEach(file => URL.revokeObjectURL(file.props.preview))
    }
    else if (this.props.pocket && this.props.files?.length > 0) {
      this.props.files.forEach(file => URL.revokeObjectURL(file.props.preview))
    }
    return null
  }

  componentDidUpdate(prevProps) {
    console.log('componentDidUpdate', prevProps.files, this.props.files);
    if (prevProps.files !== this.props.files) {
      this.setState({ files: this.props.files });
    }
  }

  handleOnDropFiles = async (newAcceptedFiles) => {
    let files = [];
    if (this.props.pocket) {
      this.setState({ isLoadingUpload: true });
      files = this.props.files || [];
      const { multiple, onFilesChange } = this.props;
      console.log('handleOnDropFiles', newAcceptedFiles);
      const acceptedFormatted = newAcceptedFiles.map((file) => {
        const icon = this.formatFileIcon(this.props.pocket ? file.data.type : file.type);
        const extension = this.extractFileExtension(this.props.pocket ? file.data.path : file.path);
        const name = this.props.pocket ? file.data.path.replace(/\.[^/.]+$/, '') : file.path.replace(/\.[^/.]+$/, '');

        return {
          data: this.props.pocket ? file.data : file,
          props: {
            id: uuidv4(),
            preview: URL.createObjectURL(this.props.pocket ? file.data : file),
            modified: moment().format('DD/MM/YYYY HH:mm'),
            icon,
            extension,
            name,
            documentType: null,
            description: null,
          },
        };
      });

      console.log('acceptedFormatted', acceptedFormatted);
      const updatedFiles = multiple ? files.concat(acceptedFormatted) : acceptedFormatted;

      this.setState({ files: updatedFiles });
      onFilesChange(updatedFiles); // Notify parent

      if(this.props.tpDocumentoId && this.props.registro && this.props.tabRef) {
        // Cria um registro na tabela de documentos para cada arquivo
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: this.props.tpDocumentoId,
            documento_desc: `${updatedFiles[0].data.path}`,
            documento_iniVig: undefined,
            documento_fimVig: undefined,
            documento_dtEmissao: undefined,
            documento_prazo: undefined,
            documento_ref: undefined,
            privacidade_id: 2,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        // Cria uma vinculação entre o documento (anexo) e o registro da minuta
        if (documentCreated.data[0].documento_id) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: this.props.tabRef,
              documentoVinc_tabId: this.props.registro[`${this.props.tabRef}_id`],
            },
          }
          await oikosApi.post('/', vinculationBody)
        }

        // Faz upload do arquivo e registra na tabela 'arquivo'
        const formData = new FormData()
        formData.append('file', new Blob([updatedFiles[0].data], { type: updatedFiles[0].data.type }), updatedFiles[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', updatedFiles[0].data.path)
        const fileUploadRes = await oikosApi.post('/', formData)
        console.tron.log('fileUploadRes', fileUploadRes)

        await this.props.updateBdroRecord(this.props.registro[`${this.props.tabRef}_id`]); // Atualiza o registro do borderô para mostrar o novo anexo
      } else {
        notifyError("Parâmetros não foram informados no script")
      }
      this.setState({ isLoadingUpload: false, pendingFile: null });
      notifySuccess("Arquivo enviado com sucesso!");
    } else {
      files = this.state.files || [];
      const { multiple, onFilesChange } = this.props;
      console.log('handleOnDropFiles', newAcceptedFiles);
      const acceptedFormatted = newAcceptedFiles.map((file) => {
        const icon = this.formatFileIcon(this.props.pocket ? file.data.type : file.type);
        const extension = this.extractFileExtension(this.props.pocket ? file.data.path : file.path);
        const name = this.props.pocket ? file.data.path.replace(/\.[^/.]+$/, '') : file.path.replace(/\.[^/.]+$/, '');

        return {
          data: this.props.pocket ? file.data : file,
          props: {
            id: uuidv4(),
            preview: URL.createObjectURL(this.props.pocket ? file.data : file),
            modified: moment().format('DD/MM/YYYY HH:mm'),
            icon,
            extension,
            name,
            documentType: null,
            description: null,
          },
        };
      });
      console.log('acceptedFormatted', acceptedFormatted);
      const updatedFiles = multiple ? files.concat(acceptedFormatted) : acceptedFormatted;

      this.setState({ files: updatedFiles });
      onFilesChange(updatedFiles); // Notify parent
    }
  }

  getFiles = () => {
    return this.state.files;
  }

  formatFileIcon = type => {
    switch (type) {
      case 'application/pdf': return {
        color: '#ffcfcc',
        labelColor: '#FF2116',
        type: 'acrobat',
      }
      case 'image/png':
      case 'image/jpeg':
      case 'image/gif':
        return {
          color: '#ffe6cc',
          labelColor: '#ff9933',
          type: 'image',
        }
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return {
        color: '#d7f4e4',
        labelColor: '#207245',
        type: 'spreadsheet',
      }
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': return {
        color: '#d7e3f4',
        labelColor: '#2a5699',
        type: 'document',
      }
      default: return {}
    }
  }

  extractFileExtension = path => {
    const fileExtensionPattern = /\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gmi

    return path.match(fileExtensionPattern)[0].substring(1)
  }

  handleDeleteFile = id => {
    const { files } = this.state;
    const { onFilesChange } = this.props;

    const filteredFiles = files.filter((file) => file.props.id !== id);

    this.setState({ files: filteredFiles });
    onFilesChange(filteredFiles); // Notify parent
  }

  handlePendingFile = (newAcceptedFiles) => {
    let files = [];
    if (this.props.pocket) {
      files = this.props.files || [];
    } else {
      files = this.state.files || [];
    }
    const { multiple, onFilesChange } = this.props;

    const acceptedFormatted = newAcceptedFiles.map((file) => {
      const icon = this.formatFileIcon(file.type);
      const extension = this.extractFileExtension(file.path);
      const name = file.path.replace(/\.[^/.]+$/, '');

      return {
        data: file,
        props: {
          id: uuidv4(),
          preview: URL.createObjectURL(file),
          modified: moment().format('DD/MM/YYYY HH:mm'),
          icon,
          extension,
          name,
          documentType: null,
          description: null,
        },
      };
    });
    console.log('acceptedFormatted', acceptedFormatted);
    const updatedFiles = multiple ? files.concat(acceptedFormatted) : acceptedFormatted;

    if (this.props.pocket) {
      this.setState({ pendingFile: updatedFiles }); // Notify parent
    } else {
      this.setState({ files: updatedFiles });
      onFilesChange(updatedFiles); // Notify parent
    }
  }

  handleOpenDropModal = () => {
    this.setState({ salvarAnexoModalIsOpen: true });
  }
  handleCloseDropModal = () => {
    this.setState({ salvarAnexoModalIsOpen: false });
  };

  render() {

    return (
      <>
        {(!this.state.isLoadingUpload) && this.state.files?.length > 0 && this.state.files.map((file) => (
          <div key={file.props.id}>
            <Row className="d-flex no-gutters align-items-center justify-content-between">
              <div className="mr-3" style={{ width: 36, height: 43 }}>
                <FileIcon
                  radius={4}
                  extension={file.props.extension}
                  type={file.props.icon.type}
                  color={file.props.icon.color}
                  labelColor={file.props.icon.labelColor}
                />
              </div>

              <div className="d-flex flex-column flex-grow-1 mr-3" style={{ width: 1 }}>
                <h6>
                  <TruncateString
                    text={file.data.path}
                  />
                </h6>

                <span>
                  {filesize(file.data.size, { locale: 'pt-BR', round: 0 })}
                </span>

              </div>

              <div className="d-flex justify-content-end">
                <Button
                  color="light"
                  size="sm"
                  title="Excluir"
                  onClick={() => this.handleDeleteFile(file.props.id)}
                >
                  <i className="ri-delete-bin-6-line font-size-16" />
                </Button>
              </div>
            </Row>

            {((!this.props.multiple && this.state.files?.length <= 0) || this.props.multiple) && (
              <Row>
                <Col>
                  <hr />
                </Col>
              </Row>
            )}
          </div>
        ))}

        {((this.state.files?.length <= 0) || this.state.multiple) && (!this.state.isLoadingUpload) && (
          (() => {
            const dropzone = (
              <Dropzone
                accept={this.props.accept || undefined}
                multiple={this.props.multiple}
                maxFiles={this.props.maxFiles || 100}
                minSize={1}
                maxSize={100000000}
                onDrop={(files) => {
                  if(this.props.pocket) {
                    this.handlePendingFile(files);
                    this.handleOpenDropModal();
                  } else {
                    this.handleOnDropFiles(files)
                  }
                }}
              >
                {({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, isFocused }) => {
                  const style = {
                    ...(this.props.compact ? compactStyle : baseStyle),
                    ...(isDragActive ? activeStyle : {}),
                    ...(isDragAccept ? acceptStyle : {}),
                    ...(isDragReject ? rejectStyle : {}),
                    ...(isFocused ? focusStyle : {}),
                  }

                  return (
                    <div {...getRootProps({ style })} className="files-dropzone">
                      <input {...getInputProps()} />
                      {!this.props.pocket &&
                        <Row>
                          <Col>
                            <i
                              className="ri-upload-cloud-2-line mb-3"
                              style={{
                                fontSize: 42,
                                color: '#4aa3ff',
                                opacity: 0.8,
                              }}
                            />
                          </Col>
                        </Row>
                      }
                      {!this.props.pocket ? (
                        <Row>
                          <Col>
                            <h6>
                              Arraste e solte ou clique para buscar
                            </h6>
                          </Col>
                        </Row>
                      ) : this.props.compact ? (
                        <span style={{ fontSize: 11, fontWeight: 600, lineHeight: 1 }}>
                          {this.props.compactLabel || '+'}
                        </span>
                      ) : (
                        <span style={{ textWrap: 'auto' }}>Arraste e solte ou clique para buscar</span>
                      )}
                      {this.props.accept && !this.props.pocket && (
                        <Row>
                          <Col>
                            <span>
                              {'Extensões permitidas: '}
                              {this.props.accept.map((f, i) => {
                                if (i + 1 === this.props.accept.length) return f
                                return `${f}, `
                              })}
                            </span>
                          </Col>
                        </Row>
                      )}

                    </div>
                  )
                }}
              </Dropzone>
            )
            if (this.props.compact) {
              return <span className="d-inline-flex align-items-center">{dropzone}</span>
            }
            return (
              <Row>
                <Col>
                  {dropzone}
                </Col>
              </Row>
            )
          })()
        )}

        {
          (this.state.isLoadingUpload) && (
            <Spinner />
          )
        }

        <ModalConfirmacao
          openModal={this.state.salvarAnexoModalIsOpen}
          onClosed={()=>this.setState({ salvarAnexoModalIsOpen: false, pendingFile: null })}
          title={`Salvar o documento ${this.state.pendingFile && this.state.pendingFile[0]?.data.path} como ${this.props.documentLabel || 'anexo'}?`}
          subtitle={`Essa ação será irreversível.`}
          confirmButtonText='Confirmar'
          onConfirm={()=>{ this.handleOnDropFiles(this.state.pendingFile); this.setState({ notaFiscalFile: this.state.pendingFile, pendingFile: null, salvarAnexoModalIsOpen: false }); }}
        />
      </>
    )
  }
}

const baseStyle = {
  cursor: 'pointer',
  //padding: '15px 16px 22px 16px',
  borderWidth: 2,
  borderRadius: 6,
  borderColor: '#ccc',
  borderStyle: 'dashed',
  backgroundColor: '#f8f8f8',
  outline: 'none',
  transition: 'all .24s ease-in-out',
  textAlign: 'center',
}

const compactStyle = {
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 22,
  minWidth: 22,
  padding: 0,
  borderWidth: 0,
  borderRadius: 0,
  borderColor: 'transparent',
  borderStyle: 'none',
  backgroundColor: 'transparent',
  outline: 'none',
  transition: 'opacity .15s ease-in-out',
  textAlign: 'center',
  color: 'inherit',
}

const activeStyle = {
  borderColor: '#4aa3ff',
  color: '#4aa3ff',
}

const focusStyle = {}

const acceptStyle = {
  borderColor: 'green',
  color: 'green',
}

const rejectStyle = {
  borderColor: 'red',
  color: 'red',
}
